<template>
  <!--  dispatch-->
  <divs  style="position: relative">
      <div class="out_big_box">
        <GmapMap
          ref="dispatch_gmap"
          :center="centers"
          :zoom="initializedZooms"
          map-type-id="roadmap"
          class="gmap"
          :options="mapOptionss"
          @drag="dragMap"
        >
          <!--      地图画线-->
          <GmapPolyline
            :path="map_draw_line_arr"
            :strokeWeight="3"
            strokeColor="#E0E0E0"
          />
          <!--      这里进行分类  店铺的点、司机的点、任务的点-->
          <!--这里是店铺的点-->
          <template v-for="(store,index) in map_hub_list">
            <GmapMarker
              :key="store.id"
              :position="store.position"
              :clickable="true"
              :title="store.name"
              :icon="{url:icons.icon_home,scaledSize:{width:24,height:24},anchor:{x:12,y:12}}"
            />
          </template>
          <!--      这里是司机的点-->
          <template  v-for="(driver,index) in mapDriverList">
            <GmapMarker
              v-if="driver.show_map && driver.is_online==1"
              :key="driver.worker_id"
              ref="driver-marker"
              :position="driver.position"
              :title="driver.name"
              :icon="{url:getIcon(driver),scaledSize:{width:16,height:16}}"
              @click="openDriverInfoWindowTemplate(index,driver)"
              :z-index="60">
              <gmap-info-window
                :options="{maxWidth: 300,pixelOffset: { width: driver_info_width,height: 30 } }"
                :position="driver.position"
                :opened="driver.open">
                <div class="windowMes" id="driver_info_box">
                  <div class="first">{{driver.name}}</div>
                </div>
              </gmap-info-window>
            </GmapMarker>
          </template>
          <!--      这里是任务的点-->
            <gmap-cluster
              :renderer="clusterRenderer"
              :onClusterClick="onClusterClick"
            >
              <template  v-for="(task,index) in map_task_list">
                <gmap-marker
                  @click="clickGmapMarker(task,index)"
                  :key="task.task_id + 'task'"
                  :options="{
                  task_id:task.task_id,
                  status:task.status,
                  success:task.success,
                  mean:task.mean,
                  is_pickup:task.is_pickup,
                  invoice_number:task.invoice_number,
                  parent_store:task.parent_store,
                  parent_driver:task.parent_driver,
                  abs:task.abs,
                  open:task.open
                  }"
                  ref="driver-marker"
                  :position="task.position"
                  :title="task.address"
                  :z-index="60"
                  :custom-param="{id:task.task_id,status:task.status}"
                  :icon="{url:getChangeIcons(task),scaledSize:{width:16,height:16},anchor:{x:8,y:8},labelOrigin:{x:8,y:8}}"
                  v-if="task.show_map_tesk"
                >
                  <gmap-info-window
                    :options="{maxWidth: 300,pixelOffset: { width: infoWindowWidth,height: 42 }}"
                    :position="task.position"
                    :opened="task.open"
                    v-if="task.open == true"
                    @closeclick="task.open=false">
                    <div class="windowMes" id="infoWindowContent">
                      <div class="first">{{task.address}}{{',' + "&nbsp;"+task.abs}}</div>
                      <div>{{task.invoice_number}} </div>
                    </div>
                  </gmap-info-window>
                  <gmap-info-window
                    :position="task.position"
                    :opened="task.open_index"
                    :options="{pixelOffset: { width: 20,height:15}}"
                    v-if="task.open_index"
                    :disableAutoPan="true"
                  >
                    <div class="windowMes" id="infoWindowContent_index">
                      <div v-if="map_draw_line_arr[0]?.type == 'driver'">{{task.index}} </div>
                      <div v-else>{{task.index +1}} </div>
                    </div>
                  </gmap-info-window>
                </gmap-marker>
              </template>

            </gmap-cluster>
          <GmapMarker>
            <!--    聚合点的右侧弹出框-->
            <gmap-info-window
              :options="{maxWidth: 300,pixelOffset: { width: cluster_infoWindowWidth,height:cluster_infoWindowHight}}"
              :position="sidebarPosition"
              :opened="showRightSidebar"
              @closeclick="showRightSidebar=false"
            >
              <div class="cluster_title">
                {{selectedMarkers.length}} Tasks
              </div>
              <div class="content"
                   id="cluster_info"
                   v-for="(item,index ) in selectedMarkers"
                   :key="index"
                   @click="clusterFindTaskHandle(item,index)"
              >
                <div style="display: flex;padding: 4px">
                  <div>
                    <img :src="getChangeIcons(item)" alt="">
                  </div>
                  <div>
                    <div class="inner_content top">{{item.address}}{{',' + "&nbsp;"+ item.abs}}</div>
                    <div class="inner_content">{{item.invoice_number}}</div>
                  </div>
                </div>
              </div>
            </gmap-info-window>
          </GmapMarker>
          <template slot="visible">
            <div class="controls">
              <div class="control-button fullscreen" @click="fullScreen">
                <svg v-if="!isFullScreen" class="icon" viewBox="0 0 12 12" width="12" height="12">
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g transform="translate(-190.000000, -98.000000)" fill="#1F2D42" fill-rule="nonzero">
                      <g transform="translate(184.000000, 92.000000)">
                        <g transform="translate(6.000000, 6.000000)">
                          <path
                            d="M10.8,0 C11.4627491,0 12,0.537256433 12,1.2 L12,1.2 L12,10.8 C12,11.4627508 11.4627508,12 10.8,12 L10.8,12 L1.2,12 C0.537256433,12 0,11.4627491 0,10.8 L0,10.8 L0,1.2 C0,0.53725815 0.53725815,0 1.2,0 L1.2,0 Z M6.6,1.2 L1.2,1.2 L1.2,10.8 L10.8,10.8 L10.8,5.399 L7.2,5.4 C6.90176624,5.4 6.65435325,5.18241039 6.60785299,4.89732312 L6.6,4.8 L6.6,1.2 Z M5.7,5.7 L5.74668425,5.70178934 L5.81929063,5.71185863 L5.88728551,5.72984285 L5.95393293,5.75620402 L6.01242525,5.78759727 L6.07526939,5.83181326 L6.12426407,5.87573593 C6.1455005,5.89697236 6.16481223,5.91940465 6.18219925,5.94281603 L6.2251973,6.00956274 L6.25726471,6.07719839 L6.27849291,6.14040422 L6.29596336,6.23002732 L6.3,6.3 L6.3,8.4 C6.3,8.73137085 6.03137085,9 5.7,9 C5.3922985,9 5.1386957,8.76837589 5.10403664,8.46997268 L5.1,8.4 L5.1,7.7484 L3.12426407,9.72426407 C2.88994949,9.95857864 2.51005051,9.95857864 2.27573593,9.72426407 C2.05944555,9.50797369 2.04280783,9.16763506 2.22582277,8.93226033 L2.27573593,8.87573593 L4.2504,6.9 L3.6,6.9 C3.26862915,6.9 3,6.63137085 3,6.3 C3,5.9922985 3.23162411,5.7386957 3.53002732,5.70403664 L3.6,5.7 L5.7,5.7 Z M10.8,1.2 L7.8,1.2 L7.8,4.2 L10.8,4.2 L10.8,1.2 Z"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
                <svg v-else viewBox="0 0 12 12" width="12" height="12">
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g transform="translate(-190.000000, -18.000000)" fill="#1F2D42" fill-rule="nonzero">
                      <g transform="translate(184.000000, 12.000000)">
                        <g transform="translate(6.000000, 6.000000)">
                          <path
                            d="M10.8,0 C11.4627491,0 12,0.537256433 12,1.2 L12,1.2 L12,10.8 C12,11.4627508 11.4627508,12 10.8,12 L10.8,12 L1.2,12 C0.537256433,12 0,11.4627491 0,10.8 L0,10.8 L0,1.2 C0,0.53725815 0.53725815,0 1.2,0 L1.2,0 Z M6.6,1.2 L1.2,1.2 L1.2,10.8 L10.8,10.8 L10.8,5.399 L7.2,5.4 C6.90176624,5.4 6.65435325,5.18241039 6.60785299,4.89732312 L6.6,4.8 L6.6,1.2 Z M6.12426407,5.87573593 C6.34055445,6.09202631 6.35719217,6.43236494 6.17417723,6.66773967 L6.12426407,6.72426407 L4.1484,8.7 L4.8,8.7 C5.13137085,8.7 5.4,8.96862915 5.4,9.3 C5.4,9.6077015 5.16837589,9.8613043 4.86997268,9.89596336 L4.8,9.9 L2.66444393,9.89895206 L2.58070937,9.88814137 L2.51271449,9.87015715 L2.44606707,9.84379598 L2.38757475,9.81240273 L2.33226033,9.77417723 L2.27587895,9.72438109 C2.2544995,9.70302764 2.23518777,9.68059535 2.21780075,9.65718397 L2.1748027,9.59043726 L2.14273529,9.52280161 L2.12150709,9.45959578 L2.10403664,9.36997268 L2.1,9.3 L2.1,7.2 C2.1,6.86862915 2.36862915,6.6 2.7,6.6 C3.0077015,6.6 3.2613043,6.83162411 3.29596336,7.13002732 L3.3,7.2 L3.3,7.8504 L5.27573593,5.87573593 C5.51005051,5.64142136 5.88994949,5.64142136 6.12426407,5.87573593 Z M10.8,1.2 L7.8,1.2 L7.8,4.2 L10.8,4.2 L10.8,1.2 Z"/>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="control-button zoom-in" @click="zoomIn">+</div>
              <div class="control-button zoom-out" @click="zoomOut">-</div>
              <div class="control-button reset" @click="toStoreCenter">
                <svg viewBox="0 0 1024 1024" width="12" height="12">
                  <path
                    d="m945.777778,490.666667l-80.924445,0c-6.698667,-173.752889 -141.127111,-315.264 -311.879111,-332.984889l0,-79.459556a28.444444,28.444444 0 0 0 -56.888889,0l0,78.236445c-178.062222,10.467556 -320.554667,155.207111 -327.452444,334.208l-90.410667,0a28.444444,28.444444 0 0 0 0,56.888889l92.856889,0c20.565333,165.034667 156.928,294.584889 325.006222,304.455111l0,93.767111a28.444444,28.444444 0 0 0 56.888889,0l0,-94.990222c160.881778,-16.696889 289.493334,-143.331556 309.432889,-303.232l83.370667,0a28.444444,28.444444 0 0 0 0,-56.888889zm-392.803556,302.606222l0,-46.606222a28.444444,28.444444 0 0 0 -56.888889,0l0,48.071111c-136.618667,-9.656889 -247.281778,-113.649778 -267.320889,-247.182222l48.568889,0a28.444444,28.444444 0 0 0 0,-56.888889l-51.470222,0c6.826667,-147.555556 123.576889,-266.609778 270.222222,-276.949334l0,63.616a28.444444,28.444444 0 0 0 56.888889,0l0,-62.165333c139.278222,17.379556 248.049778,133.205333 254.648889,275.498667l-60.956444,0a28.444444,28.444444 0 0 0 0,56.888889l58.055111,0c-19.256889,128.412444 -122.339556,229.575111 -251.747556,245.717333z"/>
                </svg>
              </div>
            </div>
          </template>
        </GmapMap>
        <template>
          <drag-tree  class="right_tree" style="display: block"
                      ref="cus_tree"
                      @findMarker="findMarkerHandle"
                      @openDriverInfo="openDriverInfoHandle"
          ></drag-tree>
          <!--        @changeDriverMapList="changeDriverMapList"-->
        </template>
        <div class="btom">
          <bottom-box
            @update="updateMapData"
            :taskId="taskId"
            :propDriverData="driverList"
            @btomSetHandle="btomSetHandle"
            @btomSetDriverHandle="btomSetDriverHandle"
          ></bottom-box>
        </div>
      </div>
  </divs>
</template>
<script>
import dispatch from "@/view/dispatch_test/index/index_js/dispatch";
export default dispatch;
</script>

<style scoped lang="less">
@import "index_css/dispatch";
</style>
